import { motion } from 'framer-motion';
import AIIcon from '@/assets/pngs/ai_icon.svg';
import { cn } from '@/lib/utils';

const Spinner = ({ className, ...props }) => {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn('relative rounded-full animate-spin', 'size-36', className)}
      style={{
        background: 'conic-gradient(from 0deg at 50% 50%, var(--color-bg) 0deg,var(--color-bg-primary) 360deg)',
      }}
      {...props}
    >
      {/* Inner dark circle to create ring effect */}
      <div className="absolute inset-4 bg rounded-full" />
    </div>
  );
};

const Loader = ({ className, ...props }) => {
  return (
    <div
      className={cn('fixed inset-0 flex flex-col items-center justify-center bg-background z-50', className)}
      {...props}
    >
      <Spinner />
      <div className="text-center mt-6">
        <p className="text-base font-medium mb-1 text">Loading...</p>
        <p className="text-sm text-muted">Please wait while we prepare your workspace.</p>
      </div>
    </div>
  );
};

const ChatThinkingLoader = () => {
  return (
    <div className="flex items-center gap-2">
      {/* Sparkle icon with glow + pulsing animation */}
      <motion.div
        animate={{ scale: [1, 1.3, 1], opacity: [0.8, 1, 0.8] }}
        transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
        className="text-blue-500 drop-shadow-[0_0_8px_rgba(59,130,246,0.8)]"
      >
        <img src={AIIcon} alt="Create Incident" />
      </motion.div>

      {/* Gradient shimmer text */}
      <motion.span
        className="font-medium text-transparent bg-clip-text bg-gradient-to-r from-[#B6F4FF] via-[#6C94FF] to-[#A497FF]"
        animate={{
          backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'linear',
        }}
        style={{
          backgroundSize: '200% auto',
        }}
      >
        OPTI is thinking...
      </motion.span>
    </div>
  );
};

export { Loader, Spinner, ChatThinkingLoader };
